import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-load-more-button',
  templateUrl: './load-more-button.component.html',
  styleUrls: ['./load-more-button.component.scss'],
  standalone: false
})
export class LoadMoreButtonComponent {
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() visible: boolean = true;

  @Output() clicked = new EventEmitter<void>();

}
